<template>
  <div>
    <app-header />

    <div class="container my-5">
      <div class="row" v-if="!loading">
        <div class="col-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ agreement.title }}</h4>
              <div class="row text-muted mb-1">
                <div class="col">Version:</div>
                <div class="col-auto">
                  <strong>{{ agreement.version }}</strong>
                </div>
              </div>
              <div class="row text-muted">
                <div class="col">Filename:</div>
                <div class="col-auto">
                  <strong>{{ agreement.filename }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Update File</h4>
              <div class="mb-3">
                <label class="form-label">Upload Agreement</label>
                <input type="file" id="file" class="form-control" ref="file" v-on:change="handleFileUpload()" />
              </div>
              <button class="btn btn-primary" v-on:click="submitFile()">Upload</button>
            </div>
          </div>
        </div>

        <div class="col-12">
          <object v-bind:data="pdfData" type="application/pdf" width="100%" height="800px"></object>
        </div>

        <div class="col-12">
          <h2 class="card-title">Template</h2>
          <div class="card">
            <div class="card-body">
              <wysiwyg-inline :content="agreement.html" :save="saveHtml"></wysiwyg-inline>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /.wrapper -->
</template>

<script>
import { http } from 'utils'
import { cloneDeep } from 'lodash'
import { mapState, mapActions } from 'vuex'
import { WysiwygInline } from 'components/form/input'

export default {
  components: {
    WysiwygInline,
  },

  data: function() {
    return {
      link: null,
      editAgreement: {},
      data: [],
      loading: true,
      file: '',
    }
  },

  computed: {
    ...mapState('projectAgreement', { agreement: 'single' }),
    pdfData() {
      return 'data:application/pdf;base64,' + this.agreement.pdf
    },
  },

  created: function() {
    this.loadData()
  },

  mounted() {},
  methods: {
    ...mapActions('projectAgreement', {
      getAgreement: 'getSingle',
      updateAgreement: 'updateSingle',
      setAgreement: 'setSingle',
    }),
    loadData() {
      this.getAgreement(this.$route.params.project_agreement_id).then(() => {
        this.editAgreement = cloneDeep(this.agreement)
        this.loading = false
      })
    },
    saveHtml(data) {
      return this.updateAgreement({ id: this.agreement.id, payload: { html: data } })
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0]
    },
    submitFile() {
      let formData = new FormData()
      formData.append('pdf', this.file)
      formData.append('_method', 'put') //PUT + multipart form request + php = no

      http
        .post('/project-agreements/' + this.$route.params.project_agreement_id, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(response => {
          this.setAgreement(response.data)
          this.$refs.file.value = null
        })
    },
  },
}
</script>

<style scoped>
ol {
  counter-reset: item;
  padding-left: 10px;
}
li {
  display: block;
}
li:before {
  content: counters(item, '.') ' ';
  counter-increment: item;
}
</style>
